import nbsp from '@/assets/js/nbsp'

export default {
  about: 'o nas',
  aboutAnalysisTitle: 'analizy',
  aboutAnalysisDescription: nbsp('dokumentów planistycznych i chłonności'),
  aboutArchitectureTitle: 'budynki',
  aboutArchitectureDescription: nbsp(`
    projektowane w relacji z kontekstem urbanistycznym
  `),
  aboutConsultancyTitle: 'doradztwo',
  aboutConsultancyContent: nbsp(`
    <p>We wszystkich naszych działaniach kładziemy duży nacisk na jakość 
    przestrzeni publicznej i funkcjonalne powiązanie budynków z ich otoczeniem. 
    Cechującej nasze projektowe wysiłki dbałości o przestrzeń zawdzięczamy 
    również liczne nagrody w konkursach urbanistyczno-architektonicznych, 
    w których braliśmy udział (w zespołach).</p><p>Inną, równie ważną domeną 
    naszej działalności, jest związane z projektowaniem doradztwo w procesach 
    inwestycji budowlanych. Gąszcz przepisów i trudnych do ogarnięcia
    lokalnych uwarunkowań niejednokrotnie utrudnia inwestorom nawet samo 
    rozpoczęcie procesu inwestycyjnego. Korzystając z całej naszej fachowej 
    wiedzy i doświadczenia staramy się wspierać naszych klientów w osiągnięciu sukcesu.</p>
  `),
  aboutContent: nbsp(`
    <p>Dobra architektura nie może istnieć bez kontekstu, który ją uzupełnia 
    i współtworzy. Zaś dla architekta i urbanisty najważniejszy powinien być 
    człowiek, który będzie użytkownikiem zaprojektowanej przez niego 
    przestrzeni. Ludzie oczekują dzisiaj od otaczającej ich przestrzeni przede 
    wszystkim tego, że będzie przyjaznym miejscem do życia – mieszkania, pracy,
    zakupów, spędzania wolnego czasu, rozrywki. Dlatego - dla pełnego sukcesu 
    projektu – użytkownicy przestrzeni muszą być również uczestnikami procesu 
    projektowego. Nie ma dobrej architektury bez właściwie zaprojektowanej 
    przestrzeni, a dobra przestrzeń nie powstaje bez udziału architekta.</p>
    <p>Tymi zasadami kierujemy się przede wszystkim w naszych działaniach. 
    Tworzymy zespół doświadczonych architektów, z których każdy ma już 
    kilkunastoletnią praktykę zawodową. Główna domeną naszej działalności jest 
    kompleksowe połączenie urbanistyki i architektury. Zespół posiada bogate 
    doświadczenie w przygotowywaniu projektów i opracowań z wielu kategorii
    projektowych.</p>
  `),
  aboutEvaluationTitle: 'opinie i opracowania',
  aboutPlanningTitle: 'zespoły zabudowy',
  aboutPlanningDescription: nbsp(`
    od pojedynczych kwartałów po nowe założenia urbanistyczne
  `),
  aboutPublicTitle: 'projektowanie przestrzeni publicznej',
  aboutPublicDescription: nbsp('ulice, place, parki'),
  aboutStudiesTitle: 'studia',
  aboutStudiesDescription: nbsp(`
    kształtowanie dużych struktur urbanistycznych, miejscowe plany 
    zagospodarowania przestrzennego, studia uwarunkowań i kierunków 
    zagospodarowania przestrzennego
  `),
  aboutTitle: nbsp(`
    W oczywisty sposób życie między budynkami jest bogatsze, bardziej 
    stymulujące i bardziej zadowalające niż jakakolwiek kombinacja
    kolorowego betonu i zachwianych form budynków
  `),
  aboutTitleAuthor: 'Jan Gehl – architekt i urbanista',
  aboutTitleAuthorLink: 'https://pl.wikipedia.org/wiki/Jan_Gehl',
  analysis: 'analizy',
  architecture: 'architektura',
  associateHeading: 'zarząd / wspólnicy',
  companyAddress: 'adres spółki',
  companyInformation: 'dane spółki',
  companyStreetAddress: 'Al. Szucha 2/4 lok. 39',
  companyStreetAddressAdditional: 'klatka E, piętro 3.',
  contact: 'kontakt',
  cooperationHeading: 'zespół / współpraca',
  jobHeading: 'zatrudnienie / stażyści',
  linksHeading: 'linki',
  mapHeading: 'jak dojechać?',
  nextPage: 'następna',
  nextProject: 'następny',
  planning: 'planowanie',
  previousPage: 'poprzednia',
  previousProject: 'poprzedni',
  projectCategories: 'kategorie projektów',
  projects: 'projekty',
  publicSpace: 'przestrzeń publiczna',
  studioAddress: 'adres pracowni',
  studioStreetAddress: 'ul. Puławska 34/2 (1. piętro)',
  team: 'zespół',
  info: 'info',
  trustedUs: 'zaufali nam',
  workedHeading: 'pracowali z nami'
}



// WEBPACK FOOTER //
// ./src/locale/languages/pl.js